<template>
  <v-dialog
      v-model="dialog"
      max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Удаление отдела</span>
      </v-card-title>
      <v-card-text>
        Вы уверенны что хотите удалить: <b>{{ depName }}</b> ?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="dialog=false"
        >
          Нет
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="delDep"
        >
          Удалить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "department",
  data: () => ({
    dialog: false,
    id: null,
    depName: ''
  }),
  beforeDestroy() {
    this.$store.dispatch('modalActionDep', null)
  },
  computed: {
    getStoreDep() {
      return this.$store.getters.getDepartmentsModal
    }
  },
  watch: {
    getStoreDep(val) {
      if(val) {
        this.depName = val.title
        this.id = val.id
        this.dialog = true
      }
      else {
        this.depName = ''
        this.id = null
        this.dialog = false
      }
    }
  },
  methods: {
    async delDep() {
      if (!this.id) return
      let res = await this.$store.dispatch('deleteDepartment', {id: this.id})
      if (res && res.status === 200) {
        await this.$store.dispatch('modalActionDep', null)
      }
      else alert('Что пошло не так!')
    }
  }
}
</script>

<style scoped>

</style>